import { FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from "@material-ui/core";
import React from "react";
import { ExamDayViewModel } from "../../model/ExamDayViewModel";
import { TimeSlotStructureType } from "../../model/TimeSlotStructure";
import FormGridCell from "../common/FormGridCell";
import DatePicker from "../common/datePicker/DatePicker";
import { TimeSlotStructureSelect } from "../examDay/TimeSlotStructureSelect";
import TranslatedMessage from "../translations/TranslatedMessage";

type ExamDayFieldsProps = {
  examDay: ExamDayViewModel;
  onPropertyValueChanges?: (part: Partial<ExamDayViewModel>) => void;
  minDate: Date;
  maxDate: Date;
};

const ExamDayFields: React.FunctionComponent<ExamDayFieldsProps> = ({
  examDay,
  onPropertyValueChanges,
  minDate,
  maxDate,
}) => {
  const handleTextChange =
    (key: keyof ExamDayViewModel) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      handleChange(key, event.target.value);

  const handleDateChange = (key: keyof ExamDayViewModel) => (date: Date | null) => {
    if (date) {
      handleChange(key, date);
    }
  };

  const handleTimeSlotStructureChange = (structure: TimeSlotStructureType) => {
    handleChange("timeSlotStructureType", structure);
  };

  const handleChange = (key: keyof ExamDayViewModel, value: string | string[] | Date | boolean) => {
    let part: Partial<ExamDayViewModel> = {
      [key]: value,
    };

    if (onPropertyValueChanges) {
      onPropertyValueChanges(part);
    }
  };

  const hasRoomAssignments = examDay.roomAssignments && examDay.roomAssignments.length > 0;

  const datesFilter = (date: Date | null) => {
    if (date && date >= minDate && date <= maxDate) {
      return false;
    }
    return true;
  };

  return (
    <Grid container={true} spacing={1}>
      <FormGridCell size="half">
        <React.Fragment>
          <FormLabel component="legend" required={true}>
            <TranslatedMessage id="examDay.field.type" />
          </FormLabel>
          <RadioGroup aria-label="contact1" name="contact1" value={examDay.type} onChange={handleTextChange("type")}>
            <React.Fragment>
              <FormControlLabel
                value="Written"
                control={<Radio />}
                label={<TranslatedMessage id="examDay.field.type.written" />}
                disabled={hasRoomAssignments}
              />
              <FormControlLabel
                value="Oral"
                control={<Radio />}
                label={<TranslatedMessage id="examDay.field.type.oral" />}
                disabled={hasRoomAssignments}
              />
              <FormControlLabel
                value="Correction"
                control={<Radio />}
                label={<TranslatedMessage id="examDay.field.type.correction" />}
                disabled={hasRoomAssignments}
              />
            </React.Fragment>
          </RadioGroup>
        </React.Fragment>
      </FormGridCell>
      <FormGridCell size="half">
        <DatePicker
          shouldDisableDate={datesFilter}
          label={<TranslatedMessage id="examDay.field.date" />}
          value={examDay.date}
          onChange={handleDateChange("date")}
          required={true}
        />
      </FormGridCell>
      <FormGridCell size="fill" />
      <TimeSlotStructureSelect value={examDay.timeSlotStructureType} onChange={handleTimeSlotStructureChange} />
      <FormGridCell size="fill" />
      <FormGridCell size="fill" />
    </Grid>
  );
};

ExamDayFields.defaultProps = {
  onPropertyValueChanges: () => { },
} as Partial<ExamDayFieldsProps>;

export default ExamDayFields;
